// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__10og9","signatureBlock":"Footer_signatureBlock__26rH7","signature":"Footer_signature__24VeS"};